import { Hotel } from "typings/microserviceModels/hotels-flex-module";
import * as React from "react";
import { LocalizedText, formatDateString, formatText } from "bernie-l10n";
import { ValueProposition } from "components/flexComponents/Hotels/components/ValueProposition";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { HotelNameRatingAndAddress } from "./HotelNameRatingAndAddress";
import { UitkPriceLockup } from "uitk-react-price-lockup";
import { NearestLocationContent } from "./NearestLocation/NearestLocationContent";

/**
 * CardContent which contains the overall ratings, pricing, value proposition
 * and guest amount (hard coded)
 */
export const CardContentReviewsPriceProposition = ({
  hotel,
  locale,
  context,
  isMobile,
  isViewCarousel,
  showCheckPrices,
  showGetPriceIfNoPrice
}: {
  hotel: Hotel;
  locale: string;
  context: ExtendedContextStore;
  isMobile?: boolean;
  isViewCarousel?: boolean;
  showCheckPrices?: boolean;
  showGetPriceIfNoPrice?: boolean;
}) => {
  const { formattedPrice } = hotel;
  const showCheckPricesDesktop = !isMobile && showCheckPrices;
  const isValidPrice =
    !showCheckPricesDesktop && formattedPrice && hotel.hotelPrice && hotel.hotelPrice.value !== "0";
  const dateFormat = "MMMd";
  const checkInDateFormatted = formatDateString(hotel.isoCheckIn, { skeleton: dateFormat });
  const checkOutDateFormatted = formatDateString(hotel.isoCheckOut, { skeleton: dateFormat });
  const showGetRates = !isValidPrice && !showCheckPrices && showGetPriceIfNoPrice;

  return (
    <>
      {isViewCarousel ? (
        <>
          <div className="uitk-grid">
            <div className="uitk-cell all-cell-fill">
              <div className="truncate uitk-type-heading-500 uitk-type-bold">{hotel.hotelName}</div>
            </div>
          </div>

          <div className="uitk-grid all-x-gutter-two">
            <div className="uitk-cell all-cell-fill">
              <HotelNameRatingAndAddress
                hotel={hotel}
                locale={locale}
                isViewCarousel={isViewCarousel}
                locationName={context.searchContext.location.name}
              />
              <ValueProposition hotel={hotel} />
            </div>
            {isValidPrice && (
              <UitkPriceLockup
                className="uitk-cell all-cell-shrink"
                lockupPrice={formattedPrice}
                priceCaptionFirst={formatText("hotels.price.perNight")}
                priceCaptionSecond={formatText(
                  "hotels.whenBooking",
                  checkInDateFormatted,
                  checkOutDateFormatted
                )}
              />
            )}
            {showGetRates && (
              <div className="uitk-cell all-cell-shrink uitk-type-right">
                <div className="uitk-type-600 hotelPricing">
                  <b>
                    <LocalizedText message="hotels.price.getRates" />
                  </b>
                </div>
              </div>
            )}
            <NearestLocationContent model={hotel.nearestLocation} />
          </div>
        </>
      ) : (
        <div className="uitk-grid all-x-gutter-two">
          <div className="uitk-cell all-cell-fill">
            <HotelNameRatingAndAddress
              hotel={hotel}
              locale={locale}
              isViewCarousel={isViewCarousel}
              locationName={context.searchContext.location.name}
            />
            <ValueProposition hotel={hotel} />
          </div>
          {isValidPrice && (
            <UitkPriceLockup
              className="uitk-cell all-cell-shrink"
              lockupPrice={formattedPrice}
              priceCaptionFirst={formatText("hotels.price.perNight")}
              priceCaptionSecond={formatText(
                "hotels.whenBooking",
                checkInDateFormatted,
                checkOutDateFormatted
              )}
            />
          )}
          {showGetRates && (
            <div className="uitk-cell all-cell-shrink uitk-type-right">
              <div className="uitk-type-600 hotelPricing">
                <b>
                  <LocalizedText message="hotels.price.getRates" />
                </b>
              </div>
            </div>
          )}
          <NearestLocationContent model={hotel.nearestLocation} />
        </div>
      )}
    </>
  );
};
